import AOS from "aos";

export default function initTabs() {
  class Tabs {
    constructor(elem) {
      this.elem = elem;
      this.allPanels = elem.querySelectorAll("[role=tabpanel]");
    }

    init() {
      const context = this.elem;
      const panels = this.allPanels;

      panels.forEach((panel) => {
        panel.setAttribute("aria-hidden", true);
      });

      const tabs = context.querySelectorAll("[role=tab]");
      tabs.forEach((tab) => {
        tab.addEventListener("click", (event) => {
          this.onClick(event);

          // Wait for the content to adjust before refreshing AOS
          setTimeout(() => {
            AOS.refresh();
          }, 100); // Adjust delay as needed for smooth behavior
        });
      });

      // Open the tab based on URL hash on page load
      this.openTab(window.location.hash);

      // Trigger AOS refresh after the tabs are initialized
      setTimeout(() => {
        AOS.refresh();
      }, 100); // Adjust delay as needed
    }

    onClick(event) {
      this.event = event;
      history.replaceState({}, "", event.target.getAttribute("href"));
      event.preventDefault();
      if (event.target.getAttribute("role") !== "tab") return;

      this.openTab(event.target.getAttribute("href"));
    }

    openTab(target) {
      const context = this.elem;
      let tab = target;

      if (!target) {
        tab = context
          .querySelectorAll("[role=tab]")
          .item(0)
          .getAttribute("href");
      }

      // Check if the tab starts with "#tab-"
      if (!tab.startsWith("#tab-")) {
        // Default to opening the first tab if the hash doesn't match any tab IDs
        tab = context.querySelector("[role=tab]").getAttribute("href");
      }

      this.reset();
      const activePanel = context.querySelector(tab);
      activePanel.setAttribute("aria-hidden", false);

      // Remove and re-add the class to trigger animation
      setTimeout(() => {
        activePanel.classList.add("is-visible");
      }, 10);

      context
        .querySelector(`[href="${tab}"]`)
        .setAttribute("aria-selected", true);
    }

    reset() {
      const context = this.elem;
      const panels = this.allPanels;

      panels.forEach((panel) => {
        panel.setAttribute("aria-hidden", true);
        panel.classList.remove("is-visible");
      });

      context.querySelectorAll("[role=tab]").forEach((tab) => {
        tab.setAttribute("aria-selected", false);
      });
    }
  }

  const allTabContainers = document.querySelectorAll("[data-tabs]");

  allTabContainers.forEach((el) => {
    const tab = new Tabs(el);
    tab.init();
  });
}
